// extracted by mini-css-extract-plugin
module.exports = {"Card":"Page_Card__nSeZD","Title":"Page_Title__Dkn_H","LoginButton":"Page_LoginButton__6pF17"};